import FormikTextField from '@ui-components-3/compat/lib/components/FormikTextField'
import { Formik, FormikHelpers } from 'formik'
import { useTranslation } from 'react-i18next'

import TestIds from 'util/TestIds'
import useDocumentTitle from 'hooks/useDocumentTitle'
import EmailSchema from 'schemas/EmailSchema'
import EntryFormCard from '../EntryFormCard'
import { EmailValues } from 'pages/EntryPage/EntryPage'

export type EmailSceneProps = {
  email?: string | null
  onSubmit: (values: EmailValues, form: FormikHelpers<EmailValues>) => void
  onCreateAccount: () => void
}

const LoginEmailScene = (props: EmailSceneProps) => {
  const { email, onSubmit, onCreateAccount } = props
  const { t } = useTranslation()

  useDocumentTitle(t('login.email.pageTitle'))
  return (
    <EntryFormCard prompt={t('login.email.prompt')} data-testid={TestIds.login.view.email}>
      <p className="typography-body pb-4 text-start text-neutral-600">{t('login.email.requiredFields')}</p>
      <div className="flex flex-col gap-6">
        <Formik initialValues={{ email: email ?? '' }} validationSchema={EmailSchema} onSubmit={onSubmit}>
          {({ isValid, handleSubmit, values }) => {
            return (
              <form onSubmit={handleSubmit} className="flex flex-col items-center gap-6">
                <FormikTextField
                  fullWidth
                  schema={EmailSchema}
                  label={t('login.email.emailLabel')}
                  name="email"
                  autoComplete="email"
                  data-testid={TestIds.login.input.email}
                  placeholder={t('login.email.emailPlaceholder')}
                />
                <button
                  className="btn btn-primary w-full"
                  data-testid={TestIds.login.button.continue}
                  disabled={!isValid || !values.email}
                  type="submit"
                >
                  {t('login.email.continueButton')}
                </button>
              </form>
            )
          }}
        </Formik>
        <p className="typography-body text-neutral-800">
          {t('login.email.newUser')}{' '}
          <button
            type="button"
            className="text-link-primary text-primary cursor-pointer font-semibold"
            data-testid={TestIds.login.button.forgot}
            onClick={onCreateAccount}
          >
            {t('login.email.registerLink')}
          </button>
        </p>
      </div>
    </EntryFormCard>
  )
}

export default LoginEmailScene
